import React from 'react';
import {string, shape} from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import './AppSidebarUserInfo.scss';
import Logout from '../../../Login/LogoutConnected';

AppSidebarUserInfo.propTypes = {
    userData: shape({
        picture: string,
        name: string.isRequired,
        email: string.isRequired,
    }).isRequired,
};

export default function AppSidebarUserInfo({userData}:any) {
    const {
        picture,
        name,
        email,
    } = userData;
    
    return (
        <Box className="user">
            <Avatar
                src={picture}
                alt="user avatar"
                className="user__avatar"
            />
            <Box className="user__info">
                <Typography
                    variant="h5"
                    className="user__info-text"
                >
                    {name}
                </Typography>
                <Typography
                    variant="h5"
                    className="user__info-text"
                >{email}
                </Typography>
                <Logout />
            </Box>
        </Box>
    );
}
